module.exports = __webpack_public_path__ + "img/panda.274b9844.jpg";